import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useRef, useState } from "react";
import { getCurrentDate, priority_of_issuance } from "../../../../constant";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import nodeinstance from "../../../../nodeInstance";
import { getVisaRequestData } from "../../../../store/Api/visarequestformApi";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import NodeInstance from "../../../../Global/nodeAxios";
import { axios } from "../../../../Global";
import { sortByName } from "../../../../utils/sortByName";

export default function CreateVRF({
  setAddOrEdit,
  grdesk,
  vrfdata,
  setShowPromptElement,
  setDeletePopUp,
  status,
}) {
  console.log(".........ststsus.........", status, vrfdata);
  const validationSchema = Yup.object().shape({
    sponsor_id: Yup.string(),
    nationality_id: Yup.string(),
    visa_stamp_city: Yup.string(),
    visa_profession_id: Yup.string(),
    gender: Yup.string(),
    priority_of_issuance: Yup.string(),
    total_visa: Yup.string(),
    visa_service_charge: Yup.string(),
    payment_terms_for_visa: Yup.string().nullable(),
    payment_terms_for_post_arrival: Yup.string().nullable(),
  });
  const validationSchemaTWO = Yup.object().shape({
    sponsor_id: Yup.string(),
    nationality_id: Yup.string(),
    visa_stamp_city: Yup.string(),
    visa_profession_id: Yup.string(),
    gender: Yup.string(),
    priority_of_issuance: Yup.string(),
    total_visa: Yup.string(),
    visa_service_charge: Yup.string(),
    payment_terms_for_visa: Yup.string().nullable(),
    // payment_terms_for_post_arrival: Yup.string(),
    // visa_block_number : Yup.string().required("visa block number is required")
  });
  const navigate = useNavigate();
  const token = localStorage.getItem("nodeToken");
  const {
    register,
    control,
    watch,
    handleSubmit,
    getValues,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(grdesk ? validationSchemaTWO : validationSchema),
  });
  const [fieldDropdownData, setFieldDropdowndata] = useState();
  const response = async () => {
    try {
      const data = await nodeinstance.get("/dashboard/vrf-visa/visa-details", {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (data.status === 200) {
        const payload = data.data;
        // Sort nested dropdown arrays alphabetically
        if (payload?.data?.Nationalitydata) {
          payload.data.Nationalitydata = sortByName(payload.data.Nationalitydata);
        }
        if (payload?.data?.visaprofession) {
          payload.data.visaprofession = sortByName(payload.data.visaprofession);
        }
        setFieldDropdowndata(payload);
      }
    } catch (error) {
      alert("error");
    }
  };
  const laravelToken = localStorage.getItem("token");
  const [visaProvider, setVisaProvider] = useState();
  const visa_provider = async () => {
    const response = await axios.get("dashboard/company", {
      headers: {
        Authorization: `Bearer ${laravelToken}`,
      },
    });
    if (response.status === 200) {
      console.log(
        "res?.data?.data?.visa_profession",
        response?.data?.data?.company
      );
      setVisaProvider(sortByName(response?.data?.data?.company));
    }
  };
  const [currentDate, setCurrentDate] = useState("");

  // useEffect(() => {

  // }, []);

  useEffect(() => {
    dispatch(
      setBreadCrumb([
        {
          label: "VISA REQUEST FORM SUMMARY",
          link: "/dashboard/visa-request-form",
        },
        {
          label: "OPS 1 DESK SUMMARY",
          link: `/dashboard/visa-request-form/ops-1-summary`,
        },
        {
          label: "CREATE",
        },
      ])
    );
    response();
    visa_provider();
    setCurrentDate(getCurrentDate());
  }, []);

  const genderDropdown = [
    {
      id: 1,
      Gender: "MALE",
    },
    {
      id: 2,
      Gender: "FEMALE",
    },
  ];

  const priorityIssurence = priority_of_issuance;

  const [genderData, setGenderData] = useState();
  const [ajeerData, setAjeerData] = useState();
  const handlegenderChange = (event) => {
    console.log("event to be triggred", event.target.value);
    setGenderData(event.target.value);
  };
  const [visaData, setVisaData] = useState();
  const handleVisaChange = (event) => {
    console.log("event visa", JSON.parse(event.target.value));
    setVisaData(JSON.parse(event.target.value));
  };
  const dispatch = useDispatch();
  const formRef = useRef(null);

  const formChange = (event) => {
    let formDetails = getValues();
  };
  console.log("ajeerData.......", ajeerData);
  const [issueDate, setIssueDate] = useState();
  const [expiryDate, setExpiryDate] = useState();
  const [blockNumber, setBlockNumber] = useState();
  const [arabic, setArabicText] = useState();
  const handleArabic = (e) => {
    setArabicText(e.target.value);
  };
  const [date, setDate] = useState();
  const onSubmit = async (data) => {
    console.log("........data..........", data);
    // alert("..........s.s.s.s..s.s.s.s..s.s.s.ss.s..s......")
    try {
      if (grdesk === true) {
        console.log(".....data print.....", data);
        let reqObject = {
          status: "GR APPROVED",
          visa_block_number: blockNumber,
          visa_block_issue_date: issueDate,
          visa_block_expiry_date: expiryDate,
          visa_issue_date: date,
          visa_profession_Arabic: arabic,
        };
        if (issueDate === undefined) {
          dispatch(
            setAppError({
              msg: "Visa Issue Date is required.",
              color: "success",
            })
          );
          return;
        } else if (expiryDate === undefined) {
          dispatch(
            setAppError({
              msg: "Visa Expiry Date is required.",
              color: "success",
            })
          );
        } else if (blockNumber === undefined) {
          dispatch(
            setAppError({
              msg: "Block Number is required.",
              color: "success",
            })
          );
        }
        const response = await NodeInstance.put(
          `/dashboard/vrf-visa/updateVRFByGrdesk/${vrfdata?.listData?.id}`,
          reqObject,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        console.log("log the response.......", response);
        if (response.status === 200) {
          setShowPromptElement(false);
          dispatch(
            setAppError({
              msg: response.data.message,
              color: "success",
            })
          );
        } else if (response.status === 602) {
          dispatch(
            setAppError({
              msg: "Visa Block number already issued",
              color: "error",
            })
          );
        } else if (response.message === "Validation error.") {
          dispatch(
            setAppError({
              msg: "Validation error.",
              color: "error",
            })
          );
        }
        return;
      }
      let reqObject = {
        ...data,
        visaprovider: visaData.name,
        sponsor_id: visaData.sponsor_id,
        ajeer: ajeerData,
        created_at: currentDate,
        company_id: visaData.company_id,
      };
      console.log("Data to be printed here", reqObject);

      const response = await nodeinstance.post(
        "/dashboard/vrf-visa/create",
        reqObject,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        // alert("success");
        navigate("/dashboard/visa-request-form/ops-1-summary");
        setAddOrEdit((p) => ({ ...p, routeName: "" }));
        dispatch(getVisaRequestData(token));
      }
    } catch (error) {
      console.log("error", error);
      if (error.message === "Request failed with status code 403") {
        dispatch(
          setAppError({
            msg: "Draft vrf already exist for the same requirement.",
            color: "success",
          })
        );
        return;
      }
      dispatch(
        setAppError({
          msg: error.message,
          color: "success",
        })
      );
    }
  };
  console.log("getCurrentDate", getCurrentDate());

  const oncancelClick = () => {
    if (grdesk === true) {
      setDeletePopUp(true);
      alert("sjsjsjsjsjjsjjs......");
      return;
    } else {
      navigate("/dashboard/visa-request-form/ops-1-summary");
      setAddOrEdit((p) => ({ ...p, routeName: "" }));
    }
  };

  const [nationality, setNationality] = useState("");
  const handleNationalityChange = (event) => {
    console.log("event", event.target.value);
    setNationality(event.target.value);
  };
  const [visaprofession, setVisaprofession] = useState();
  const handleVisaprofessionChange = (event) => {
    setVisaprofession(event.target.value);
  };

  useEffect(() => {
    console.log("vrfdata", vrfdata);
    setValue("visa_stamp_city", vrfdata?.listData?.visa_stamp_city);
    setValue("sponsor_id", vrfdata?.listData?.sponsor_id);
    setVisaprofession(vrfdata?.listData?.visa_profession_id);
    setNationality(vrfdata?.listData?.nationality_id);
    setGenderData(vrfdata?.listData?.gender);
    setValue("priority_of_issuance", vrfdata?.listData?.priority_of_issuance);
    setValue("total_visa", vrfdata?.listData?.total_visa);
    setValue("visa_service_charge", vrfdata?.listData?.visa_service_charge);
    setAjeerData(vrfdata?.listData?.ajeer);
    setValue(
      "payment_terms_for_visa",
      vrfdata?.listData?.payment_terms_for_visa
    );
    setValue(
      "payment_terms_for_post_arrival",
      vrfdata?.listData?.payment_terms_for_post_arrival
    );
    setVisaData({
      name: vrfdata?.listData?.company_name,
      sponsor_id: vrfdata?.listData?.sponsor_id,
    });
    console.log("eggetftyfytfyf", vrfdata?.listData?.nationality_id);
  }, [grdesk, vrfdata]);
  console.log("visaData.........kkkkk.....", visaData);

  const handleRejectClick = () => {
    setDeletePopUp(true);
  };
  console.log("visaProvider.......", visaProvider);

  console.log("summa data.........", grdesk);
  return (
    <form
      onChange={formChange}
      ref={formRef}
      onSubmit={handleSubmit(onSubmit)}
      // autoComplete="off"
    >
      <div className="flex flex-col justify-center items-center bg-white dark:bg-dark rounded-md py-5">
        <h2 className="text-xl font-semibold">CREATE VRF</h2>
        {grdesk ? (
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              VISA PROVIDER
            </label>
            <input
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              defaultValue={visaData?.name}
              disabled
            />
          </div>
        ) : (
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              VISA PROVIDER
            </label>
            <select
              // {...register("visaprovider")}
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              // value={visaData?.name}
              onChange={handleVisaChange}
            >
              <option value="">{"SELECT VALUE"}</option>
              {visaProvider?.map((data, index) => (
                <React.Fragment key={index}>
                  {/* {index === 0 ? ( */}
                  <option value={JSON.stringify(data)}>{data.name}</option>
                </React.Fragment>
              ))}
            </select>
          </div>
        )}
        <div className="flex flex-col p-2 gap-1 w-full max-w-md">
          <label htmlFor={`addOrEdit-name`} className="text-xs">
            AJEER
          </label>
          {grdesk ? (
            <label className="flex items-center">
              <input
                type="radio"
                value={ajeerData}
                checked={ajeerData}
                onChange={(event) => {
                  setAjeerData(event.target.value);
                }}
              />
              <span>{ajeerData}</span>
            </label>
          ) : (
            <div className="flex gap-10">
              <label className="flex items-center">
                <input
                  type="radio"
                  name="ajeerOption"
                  value="YES"
                  onChange={(event) => {
                    setAjeerData(event.target.value);
                  }}
                />
                <span>YES</span>
              </label>

              <label className="flex items-center">
                <input
                  type="radio"
                  name="ajeerOption"
                  value="NO"
                  onChange={(event) => {
                    setAjeerData(event.target.value);
                  }}
                />
                <span>NO</span>
              </label>
            </div>
          )}
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              DATE
            </label>
            <input
              type="Date"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              defaultValue={currentDate}
              onKeyDown={(e) => e.preventDefault()}
              disabled
            />
          </div>
          {grdesk ? (
            <div className="flex flex-col p-2 gap-1 w-full max-w-md border-3 border-green-500 dark:bg-green">
              <label
                htmlFor={`addOrEdit-name`}
                className="text-xs text-green-500"
              >
                SPONSOR ID
              </label>
              <input
                type="text"
                className="border border-red-500 dark:border-dark rounded-md p-1 py-2 text-green-300"
                value={vrfdata?.sponsor_id}
                disabled
                // {...register("sponsor_id")}
              />
            </div>
          ) : (
            <div className="flex flex-col p-2 gap-1 w-full max-w-md border-3 border-green-500 dark:bg-green">
              <label
                htmlFor={`addOrEdit-name`}
                className="text-xs text-green-500"
              >
                SPONSOR ID
              </label>
              <input
                type="text"
                className="border border-red-500 dark:border-dark rounded-md p-1 py-2 text-green-300"
                value={visaData?.sponsor_id}
                disabled
                // {...register("sponsor_id")}
              />
            </div>
          )}
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              NATIONALITY
            </label>
            <select
              {...register("nationality_id")}
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              value={nationality}
              onChange={handleNationalityChange}
              disabled={grdesk}
            >
              <option value="">{"SELECT VALUE"}</option>
              {fieldDropdownData?.data?.Nationalitydata?.map((data, index) => (
                <React.Fragment key={index}>
                  <option value={data.id}>{data.name}</option>
                </React.Fragment>
              ))}
            </select>
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              VISA STAMP CITY
            </label>
            <input
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              {...register("visa_stamp_city")}
              disabled={grdesk}
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              VISA PROFESSION
            </label>
            <select
              {...register("visa_profession_id")}
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              value={visaprofession}
              onChange={handleVisaprofessionChange}
              disabled={grdesk}
            >
              <option value="">{"SELECT VALUE"}</option>
              {fieldDropdownData?.data?.visaprofession?.map((data, index) => (
                <React.Fragment key={index}>
                  <option value={data.id}>{data.name}</option>
                </React.Fragment>
              ))}
            </select>
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs">
              GENDER
            </label>
            <select
              {...register("gender")}
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              value={genderData}
              onChange={handlegenderChange}
              disabled={grdesk}
            >
              <option value="">{"SELECT GENDER"}</option>
              {genderDropdown.map((data, index) => (
                <option key={index} value={data.Gender}>
                  {data.Gender}
                </option>
              ))}
            </select>
          </div>

          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              PRIORITY OF ISSUANCE
            </label>
            {/* <input
            type="text"
            className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
            {...register("priority_of_issuance")}
          /> */}
            <select
              {...register("priority_of_issuance")}
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              disabled={grdesk}
              // onChange={handlegenderChange}
            >
              <option value="">{"SELECT VALUE"}</option>
              {priorityIssurence.map((data, index) => (
                <option key={index} value={data.name}>
                  {data.name}
                </option>
              ))}
            </select>
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              TOTAL VISAS
            </label>
            <input
              type="number"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              {...register("total_visa")}
              disabled={grdesk}
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              VISA SERVICE CHARGE (SAR)
            </label>
            <input
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              {...register("visa_service_charge")}
              disabled={grdesk}
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              PAYMENT TERMS FOR VISA
            </label>
            <input
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              {...register("payment_terms_for_visa")}
              disabled={grdesk}
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              PAYMENT TERMS FOR POST ARRIVAL
            </label>
            <input
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              {...register("payment_terms_for_post_arrival")}
              disabled={grdesk}
            />
          </div>
          {grdesk ? (
            <>
              <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                <label htmlFor={`addOrEdit-name`} className="text-xs ">
                  VISA BLOCK NUMBER
                </label>
                <input
                  type="text"
                  className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                  value={blockNumber}
                  onChange={(e) => {
                    setBlockNumber(e.target.value);
                  }}
                />
              </div>
              <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                <label htmlFor={`addOrEdit-name`} className="text-xs ">
                  VISA ISSUE DATE
                </label>
                <input
                  type="Date"
                  value={date}
                  max={new Date().toISOString().split("T")[0]}
                  className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                  onChange={(e) => {
                    setDate(e.target.value);
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>
              <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                <label htmlFor={`addOrEdit-name`} className="text-xs ">
                  VISA BLOCK ISSUE DATE
                </label>
                <input
                  type="Date"
                  value={issueDate}
                  className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                  onChange={(e) => {
                    setIssueDate(e.target.value);
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>
              <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                <label htmlFor={`addOrEdit-name`} className="text-xs ">
                  VISA BLOCK EXPIRY DATE
                </label>
                <input
                  type="Date"
                  value={expiryDate}
                  className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                  onChange={(e) => {
                    setExpiryDate(e.target.value);
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>
              <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                <label htmlFor={`addOrEdit-name`} className="text-xs ">
                  VISA PROFESSION ARABIC
                </label>
                <input
                  type="text"
                  className="input input-sm input-bordered"
                  required
                  value={arabic}
                  onChange={(e) => {
                    handleArabic(e);
                  }}
                />
              </div>
            </>
          ) : (
            " "
          )}
          <div className="p-2  w-full max-w-md flex gap-3">
            {grdesk === true ? (
              ""
            ) : (
              <button
                className="w-full ring-1 rounded-md text-xs ring-black"
                onClick={() => oncancelClick()}
              >
                Cancel
              </button>
            )}
            <button
              className="bg-black dark:bg-red w-full text-xs text-white rounded-md py-2 flex justify-center items-center gap-2"
              type="submit"
              //   disabled={submitFormLoading}
            >
              <p>Submit</p>
              {/* {submitFormLoading ? (
                <CgSpinner className="animate-spin" />
              ) : (
                <HiArrowLongRight size={"1.2rem"} />
              )} */}
            </button>
          </div>
        </div>
      </div>
    </form>
  );
}
